module.exports = __webpack_public_path__ + "img/table4.6a3f71f8.jpg";